(function () {
    const queryAll = ( selector, ctx = document ) => ctx.querySelectorAll( selector );

    const event = new InputEvent( 'input' );

    const handle_inputs = () => {
        const input_fields = queryAll( 'input[data-clearable]:not([data-clearer-added="true"])' );
        input_fields.forEach( input => {
            input.setAttribute( 'data-clearer-added', 'true' );
            let icon = document.createElement( 'span' );
            icon.classList.add( 'icon' );
            icon.setAttribute( 'data-clearer', 'true' );

            let italic = document.createElement( 'i' );
            italic.classList.add( 'fa-solid', 'fa-circle-xmark' );
            italic.setAttribute( 'tabindex', '0' );

            italic.addEventListener( 'click', () => {
                input.value = "";
                input.focus();
                input.dispatchEvent( event );
            } );

            icon.appendChild( italic );
            input.after( icon );
        });
    };
    document.addEventListener( 'DOMContentLoaded', () => handle_inputs() );
    document.addEventListener( 'htmx:afterOnLoad', () => handle_inputs() );
})();
